import React from "react";

const LoadingSpinnerComponent = ({loading, center, size}) => {
    if (loading) {
        if (center) {
            return (
                <div style={{margin: "0 auto", textAlign: "center"}}>
                    <LoadingSpinnerBase size={size}/>
                </div>
            );
        } else {
            return (
                <div>
                    <LoadingSpinnerBase size={size}/>
                </div>
            );
        }
    } else {
        return <div/>;
    }
}

const LoadingSpinnerBase = ({size}) => {
    return (
        <React.Fragment>
            {size ? (
                <div
                    className="spinner-border"
                    role="status"
                    style={{width: size, height: size}}
                >
                    <span className="sr-only">Loading...</span>
                </div>
            ) : (
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            )}
        </React.Fragment>
    );
}

export default LoadingSpinnerComponent;
